import store from "./store";
import router from "./router";
const axios = require("axios");

export const utility = {
  data: function () {},
  methods: {
    isError(errore) {
      try {
        if (errore.trim != "") {
          return true;
        } else {
          return false;
        }
      } catch (error) {
        return false;
      }
    },
    verificaData(giorno_persona, mese_persona, anno_persona) {
      let giorno = parseInt(giorno_persona);
      let mese = parseInt(mese_persona);
      let anno = parseInt(anno_persona);

      if (isNaN(giorno) || isNaN(mese) || isNaN(anno)) {
        return false;
      }

      if ((giorno < 1) | (mese < 1) || anno < 1850) {
        return false;
      }

      switch (mese) {
        case 1:
        case 3:
        case 5:
        case 7:
        case 8:
        case 10:
        case 12:
          if (giorno > 31) {
            return false;
          }
          break;
        case 4:
        case 6:
        case 9:
        case 11:
          if (giorno > 30) {
            return false;
          }
          break;
        case 2:
          if (this.annoBisestile(anno)) {
            if (giorno > 29) {
              return false;
            }
          } else {
            if (giorno > 28) {
              return false;
            }
          }
          break;

        default:
          return false;
      }

      giorno = "00" + giorno.toString().trim();
      giorno = giorno.substring(giorno.length - 2);
      mese = "00" + mese.toString().trim();
      mese = mese.substring(mese.length - 2);
      anno = "0000" + anno.toString().trim();
      anno = anno.substring(anno.length - 4);

      if (isNaN(Date.parse(anno + "-" + mese + "-" + giorno))) {
        return false;
      }

      return true;
    },
    drizzaData(data) {
      let month = String(data.getMonth() + 1);
      let day = String(data.getDate());
      const year = String(data.getFullYear());

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return `${day}/${month}/${year}`;
    },
    annoBisestile(anno) {
      if (anno % 400 == 0) {
        return true;
      }

      if (anno % 100 == 0) {
        return false;
      }
      if (anno % 4 == 0) {
        return true;
      }

      return false;
    },
    registraErrore(messaggio, source, lineno, colno) {
      try {
        if (messaggio == undefined || messaggio == null) {
          messaggio = "";
        }
        if (source == undefined || source == null) {
          source = "";
        }
        if (lineno == undefined || lineno == null) {
          lineno = 0;
        }
        if (colno == undefined || colno == null) {
          colno = 0;
        }

        let ServerURL = store.state.ServerURL;

        let JSONMessaggio = "";
        try {
          let messaggioPulito = JSON.stringify(messaggio);
          messaggioPulito +=
            " - Utente: " +
            store.state.Utente +
            " - User agent: " +
            navigator.userAgent;
          messaggioPulito = messaggioPulito
            .replaceAll("{", "")
            .replaceAll('"', "")
            .replaceAll("/", "")
            .replaceAll("\\", "")
            .replaceAll("}", "")
            .replaceAll("[", "")
            .replaceAll("]", "");
          JSONMessaggio = "Errore locale: " + messaggioPulito;
        } catch (error) {
          JSONMessaggio =
            "Error: Errore dentro registraErrore in fase di JSON.stringify: " +
            error;
        }

        if (process.env.NODE_ENV != "production") {
          alert(messaggio + "-" + source);
        }

        if (navigator.onLine) {
          axios({
            method: "GET",
            url:
              ServerURL +
              "Checkin/RegistraErrore?errore=" +
              encodeURIComponent(JSONMessaggio) +
              "&source=" +
              source +
              "&lineno=" +
              lineno +
              "&colno=" +
              colno,
            withCredentials: true,
          });
        }

        if (store.state.ErroriBloccanti) {
          router.push({
            name: "Errore",
            params: { errore: JSONMessaggio + " - Funzione: " + source },
          });
        }
      } catch (error) {
        alert("Errore funzione registraErrore: " + error);
      }
    },
  },
};
